import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiPlus,
  FiEdit,
  FiEye,
  FiGlobe,
  FiFileText,
  FiCheckCircle,
  FiXCircle,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function WebsitePages() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [pages] = useState([
    {
      id: 1,
      pageName: "Terms & Conditions",
      slug: "terms-and-conditions",
      type: "Legal",
      status: "Published",
      lastUpdated: "2024-01-15",
      updatedBy: "Admin-001",
      version: "2.1",
    },
    {
      id: 2,
      pageName: "Privacy Policy",
      slug: "privacy-policy",
      type: "Legal",
      status: "Published",
      lastUpdated: "2024-01-10",
      updatedBy: "Admin-001",
      version: "1.5",
    },
    {
      id: 3,
      pageName: "Home Page",
      slug: "home",
      type: "Marketing",
      status: "Draft",
      lastUpdated: "2024-01-20",
      updatedBy: "Admin-002",
      version: "3.0",
    },
    {
      id: 4,
      pageName: "FAQ",
      slug: "faq",
      type: "Support",
      status: "Published",
      lastUpdated: "2024-01-05",
      updatedBy: "Admin-001",
      version: "1.2",
    },
  ]);

  const handleCreatePage = () => {
    Swal.fire({
      title: "Create New Page",
      html: `
        <input id="pageName" class="swal2-input" placeholder="Page Name" required>
        <input id="slug" class="swal2-input" placeholder="URL Slug" required>
        <select id="pageType" class="swal2-select">
          <option value="Legal">Legal</option>
          <option value="Marketing">Marketing</option>
          <option value="Support">Support</option>
        </select>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Create Page",
      confirmButtonColor: "#006e82",
    });
  };

  const handleEditPage = (pageId) => {
    Swal.fire({
      title: "Edit Page",
      html: `
        <input id="pageName" class="swal2-input" placeholder="Page Name" value="Terms & Conditions">
        <textarea id="pageContent" class="swal2-textarea" placeholder="Page Content"></textarea>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Save Changes",
      confirmButtonColor: "#006e82",
    });
  };

  const handlePublish = (pageId) => {
    Swal.fire({
      title: "Publish Page?",
      text: "This page will be published and visible to users.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Publish",
      confirmButtonColor: "#10b981",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Published!", "Page has been published.", "success");
      }
    });
  };

  const filteredPages = pages.filter((page) => {
    const matchesSearch =
      page.pageName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      page.slug.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "all" || page.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredPages.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredPages.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                    <div className="content-page-header content-page-headersplit">
                    <h5>Website Pages</h5>
                    </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/cms/website-pages">CMS</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Website Pages
                  </li>
                </ol>
              </nav>
        
           
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Filters */} 
                  <div className="row g-2 flex-grow-1">
                <div className="col-12 col-md-6">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by page name or slug..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="Published">Published</option>
                    <option value="Draft">Draft</option>
                  </select>
                </div>
                </div>
                <div className="ms-md-3 mt-3 mt-md-0">
                  <button
                    className="btn btn-primary"
                    onClick={handleCreatePage}
                  >
                    <i className="fas fa-plus me-2"></i>
                    Create Page
                  </button>
                </div>
              </div>
            </div>

            {/* Pages Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Page Name</th>
                          <th>Slug</th>
                          <th>Type</th>
                          <th>Status</th>
                          <th>Version</th>
                          <th>Last Updated</th>
                          <th>Updated By</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="8">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((page) => (
                            <tr key={page.id}>
                              <td style={{ fontWeight: "500" }}>{page.pageName}</td>
                              <td style={{ fontFamily: "monospace" }}>/{page.slug}</td>
                              <td>
                                <span className="badge" style={{
                                  background: "#f0f9ff",
                                  color: "#006e82",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {page.type}
                                </span>
                              </td>
                              <td>
                                <span className={page.status === "Published" ? "badge-active" : "badge-pending"}>
                                  {page.status}
                                </span>
                              </td>
                              <td>{page.version}</td>
                              <td>{page.lastUpdated}</td>
                              <td>{page.updatedBy}</td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleEditPage(page.id)}
                                    title="Edit Page"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </div>
                                  <div
                                    className="delete-table me-2"
                                    title="View Page"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </div>
                                  {page.status === "Draft" && (
                                    <div
                                      className="delete-table"
                                      onClick={() => handlePublish(page.id)}
                                      title="Publish Page"
                                      style={{ cursor: "pointer", color: "#10b981" }}
                                    >
                                      <i className="fas fa-check-circle"></i>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
